import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class Periodicidade extends React.Component {
  static defaultProps = {
    clearable: false,
  };

  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/PeriodicidadeLookup" clearable={this.props.clearable} {...this.props} />;
  }
}

export default Periodicidade;
